<template>
  <Toaster richColors theme="light" position="top-center" :expand="true" />
</template>

<script>
import { Toaster } from "vue-sonner";
import "vue-sonner/style.css";

export default {
  name: "ToasterBase",
  components: {
    Toaster,
  },
};
</script>
